module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/BuyReasonSection/transparency-b012d6e170eb0cabe5330a8f310d6b63.png";